import { AxiosPromise } from "axios";

import { ApiResponse } from "../models/base.model";
import apiClient from "../config/axiosConfig";
import { CommentDelete, CommentDetail } from "../models/comment.model";

class CommentService {
    createComment(
       comment:CommentDetail
      ): AxiosPromise<ApiResponse<CommentDetail>> {
        return apiClient.post(`/v1/exo/clients/${comment.clientId}/comments`, comment);
    }

    updateComment(
       comment:CommentDetail
      ): AxiosPromise<ApiResponse<CommentDetail>> {
        return apiClient.put(`/v1/exo/clients/${comment.clientId}/comments/${comment.id}`, comment);
    }

    deleteComment(
      comment:CommentDelete
     ): AxiosPromise<ApiResponse<CommentDetail>> {
       return apiClient.delete(`/v1/exo/clients/${comment.clientId}/comments/${comment.id}`,{ data: comment});
    }

    getAllComments(clientId:string): AxiosPromise<ApiResponse<Array<CommentDetail>>> {
         return apiClient.get(`/v1/exo/clients/${clientId}/comments`);
    }

}

const commentService=new CommentService();
export default commentService;